import {emotionStyled} from '@packages/utilities/styled';

export const RowItemInputLabelWrapper = emotionStyled('label')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});
